import {CardsStatementState, CardStatementAction, CardStatementActionTypes} from '../../types/cardStatement';

const initialState = {
    cardsStatementData: {},
    cardsAccountStatementData: {},
    inProgress: false,
    filterData: [],
    ccyName: {},
    blocksByIban: [],
    inProgressAccounts: false,
    accountsData: [],
    moreDetailData: {},
    ibanNumber: {},
    requisiteData: {},
    cardLoading: false,
    balanceLoading: false,
    transferWidgetLoading: false,
    type:"",
    cardArray: [],
    accountArray: []
}
const cardStatementReducer = (state = initialState, action: CardStatementAction): CardsStatementState => {
    switch (action.type) {

        case CardStatementActionTypes.GET_CARDS_STATEMENT_REQUEST:
            return {
                ...state,
                inProgress: true,
            }
        case CardStatementActionTypes.GET_CARDS_STATEMENT_SUCCESS:
            return {
                ...state,
                cardsStatementData: action.payload,
                inProgress: false,
            }
        case CardStatementActionTypes.GET_CARDS_ACCOUNT_STATEMENT_SUCCESS:
            return {
                ...state,
                cardsAccountStatementData: action.payload,
                inProgress: false,
            }
        case CardStatementActionTypes.GET_CARDS_STATEMENT_ERROR:
            return {
                ...state,
                notify: false,
                inProgress: false,

            }

        case CardStatementActionTypes.SET_CARDS_STATEMENT_FILTER:
            return {
                ...state,
                filterData: action.payload
            }

        case CardStatementActionTypes.SET_CCY_NAME:
            return {
                ...state,
                ccyName: action.payload
            }
        case CardStatementActionTypes.SET_CARDS_TYPE:
            return{
                ...state,
                type: action.payload
            }
        case CardStatementActionTypes.GET_BLOCKED_IBAN_REQUEST:
            return {
                ...state,
                inProgress: true,
            }
        case CardStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS:
            return {
                ...state,
                blocksByIban: action.payload,
                inProgress: false,
            }
        case CardStatementActionTypes.GET_BLOCKED_IBAN_ERROR:
            return {
                ...state,
                notify: false,
                inProgress: false,

            }

        case CardStatementActionTypes.GET_CARDS_DATA_REQUEST:
            return {
                ...state,
                inProgressCards: true,
            }
        case CardStatementActionTypes.GET_CARDS_DATA_SUCCESS:
            return {
                ...state,
                accountsData : action.payload.result,
                inProgressCards: false,
            }
        case CardStatementActionTypes.GET_CARDS_DATA_ERROR:
            return {
                ...state,
                notify: false,
                inProgress: false,

            }

        case CardStatementActionTypes.SET_MORE_DETAIL:
            return {
                ...state,
                moreDetailData: action.payload
            }

        case CardStatementActionTypes.SET_IBAN_NUMBER:
            return {
                ...state,
                ibanNumber: action.payload
            }

        case CardStatementActionTypes.GET_REQUISITE_REQUEST:
            return {
                ...state,
                inProgress: true,
                requisiteData: [],
            }
        case CardStatementActionTypes.GET_REQUISITE_SUCCESS:
            return {
                ...state,
                requisiteData: action.payload,
                inProgress: false,
            }
        case CardStatementActionTypes.GET_REQUISITE_ERROR:
            return {
                ...state,
                notify: false,
                inProgress: false,

            }
        case CardStatementActionTypes.SET_CARD_LOADING:
            return {
                ...state,
                cardLoading: action.payload
            }
        case CardStatementActionTypes.SET_BALANCE_LOADING:
            return {
                ...state,
                balanceLoading: action.payload
            }
        case CardStatementActionTypes.SET_TRANSFER_WIDGET_LOADING:
            return {
                ...state,
                transferWidgetLoading: action.payload
            }

        case CardStatementActionTypes.SET_CARD_ARRAY:
            return {
                ...state,
                cardArray: action.payload
            }
        case CardStatementActionTypes.SET_CARD_ACCOUNTS_ARRAY:
            return {
                ...state,
                accountArray: action.payload
            }
        case CardStatementActionTypes.CLEAR_CARD_ARRAY:
            return {
                cardsStatementData: {},
                cardsAccountStatementData: {},
                inProgress: false,
                filterData: [],
                ccyName: {},
                blocksByIban: [],
                accountsData: [],
                moreDetailData: {},
                ibanNumber: {},
                requisiteData: {},
                cardLoading: false,
                balanceLoading: false,
                transferWidgetLoading: false,
                type:"",
                cardArray: [],
                accountArray: []
            }    
        default:
            return state;
    }
}
export default cardStatementReducer
